import React from 'react';
import classNames from 'classnames';
import './Logo.scss';
import { Link } from 'react-router-dom';

const Logo: React.FunctionComponent<{ className?: any }> = React.memo(({ className }) => (
    <Link to="/"><span className={classNames('MainLogo', className)}></span></Link>
));

export default Logo;